"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialPortEvent = void 0;
var SerialPortEvent;
(function (SerialPortEvent) {
    SerialPortEvent["MESSAGE"] = "message";
})(SerialPortEvent = exports.SerialPortEvent || (exports.SerialPortEvent = {}));
//# sourceMappingURL=ISerialPort.js.map